<div *transloco="let t; prefix: 'home.services'" class="container">
    <div class="w-full pt-10 pb-8 gap-6 md:gap-10 backdrop-blur-[10px] flex-col justify-start items-start inline-flex">
        <div class="self-stretch  md:pt-6 md:pb-10 backdrop-blur-[10px] flex-col justify-start items-start gap-4 flex">
            <a (click)="backToAllServices()"
                class="cursor-pointer btn-text flex items-center justify-center md:items-start md:justify-start gap-2">
                <i class="icon-chevron-left text-[20px]"></i> {{t('view-allServices')}} </a>
            <div class="w-full flex flex-col lg:flex-row items-start lg:justify-between gap-8">
                <div class="self-stretch text-black text-[32px] font-normal">{{t(serviceData.title)}}</div>
                @if (serviceData?.logo) {
                <img [src]="serviceData.logo" class="h-12">
                }
            </div>
        </div>
        <img class="w-full h-[230px] md:h-auto  rounded-xl" [src]="serviceData.img" />
    </div>
    <div class="w-full flex flex-col xl:flex-row  md:pt-10 justify-between gap-16 mb-10">
        <div class="flex flex-col md:mr-0 gap-6 lg:mr-0 xl:w-8/12 px-0">
            <span *ngIf="serviceData.descPart1Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart1Title)"></span>
            <span *ngIf="serviceData.descPart1" [innerHTML]="t(serviceData.descPart1)"></span>
            <span *ngIf="serviceData.descPart2Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart2Title)"></span>
            <span *ngIf="serviceData.descPart2" [innerHTML]="t(serviceData.descPart2)"></span>
            @if (serviceType == serviceTypeForTemplate.preapproval) {
            <app-property-card-item [showFavorite]="false" [isClickable]="false" [propertySummary]="propertySummary"
                class="hover: cursor-none" />
            }
            <span *ngIf="serviceData.descPart3Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart3Title)"></span>
            <span *ngIf="serviceData?.descPart3" [innerHTML]="t(serviceData.descPart3)"></span>
            <span *ngIf="serviceData.descPart4Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart4Title)"></span>
            <span *ngIf="serviceData?.descPart4" [innerHTML]="t(serviceData.descPart4)"></span>
            <span *ngIf="serviceData.descPart5Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart5Title)"></span>
            <span *ngIf="serviceData?.descPart5" [innerHTML]="t(serviceData.descPart5)"></span>
            <span *ngIf="serviceData.descPart6Title" class=" font-semibold"
                [innerHTML]="t(serviceData.descPart6Title)"></span>
            <span *ngIf="serviceData?.descPart6" [innerHTML]="t(serviceData.descPart6)"></span>
            <div class="mt-6 w-full flex flex-col lg:flex-row justify-start items-start gap-4">
                <div class="grow w-full basis-0 h-[80px] p-4 rounded-lg border border-[#c2ccd3] justify-between items-center flex">
                    <div class="justify-between items-baseline gap-2 flex w-full">
                        <div class="justify-start items-baseline gap-2 flex flex-col">
                            <div class="text-[#50575f] text-base font-normal">{{t('deliveryTime')}}: 

                            </div>
                                @if (deliveryDays > 1) { 
                                    <div class="text-[#09797c] text-xl font-semibold">
                                        {{serviceData.deliveryDays}}&nbsp;{{t('deliveryDays.count_plural')}}
                                    </div> 
                                } 
                                @else { 
                                    <div class="text-[#09797c] text-xl font-semibold">
                                        {{serviceData.deliveryDays}}&nbsp;{{t('deliveryDays.count')}}
                                    </div> 
                                }
                            </div>
                        <i class="icon-info-circle" customTooltip [tooltipTemplate]="deliveryTimeTooltip"></i>
                        <ng-template #deliveryTimeTooltip> {{t('deliveryTime')}} </ng-template>
                    </div>
                </div>
                <div class="grow w-full basis-0 h-[80px] p-4 rounded-lg border border-[#c2ccd3] justify-between items-center flex">
                    <div class="justify-start items-baseline gap-2 flex flex-col">
                        <div class="text-[#50575f] text-base font-normal whitespace-nowrap">{{t('serviceFee')}}:</div>
                        <div class="flex flex-row items-center gap-2">
                            <span class="text-[#09797c] text-xl font-semibold">€{{serviceData.serviceFee}}</span>
                            @if (relatedOffer && relatedOffer.originalPrice) {
                                <span class="text-[#50575f] text-base font-normal line-through">€{{relatedOffer.originalPrice}}</span>
                            }
                        </div>
                    </div>
                    @if (relatedOffer) {
                        <div class="bg-[#09797c]/20 rounded-lg min-w-[100px] px-3 py-2">
                            <div class="flex flex-row gap-x-1 justify-between">
                                <div class="text-[#09797c] font-semibold truncate max-w-[250px] lg:max-w-[200px] xl:max-w-[120px] 2xl:max-w-[200px]">{{relatedOffer.title}}</div>
                                <span class="text-red font-semibold">{{((serviceData.serviceFee-relatedOffer.originalPrice)*100/relatedOffer.originalPrice) | number: '2.0-0' }}%</span>
                            </div>
                            <div class="text-[#09797c]/80 text-xs italic">
                                *{{t('offerValidUntil')}} {{relatedOffer.offerExpirationDate | date: 'dd/MM/yyyy'}}
                            </div>
                        </div>
                    }
                </div>
            </div> @if(serviceType == serviceTypeForTemplate.photography) { <section>
                <div class="w-full text-black text-[32px] font-semibold" [innerHTML]="t('serviceContents')"></div>
                <div class="flex flex-col mt-8 gap-8">
                    <div class="flex flex-col lg:flex-row gap-8"> @for(card of serviceData.contents.topRow; track
                        $index) { <div class="bg-white rounded-xl p-6 max-w-[417px]">
                            <img [src]="card.img" alt="" class="aspect-[370/250] rounded-extra-small">
                            <p class="text-xl text-black mt-6">{{t(card.title)}}</p>
                            <p class="text-[#50575f] mt-3">{{t(card.description)}}</p>
                            <button *ngIf="card.ctaLink && card.ctaTitle" class=" font-semibold" type="button"
                                [localizedRouterLink]="card.ctaLink"
                                class="btn-secondary mt-8">{{t(card.ctaTitle)}}</button>
                        </div> } </div>
                    <div class="flex flex-col lg:flex-row gap-8"> @for(card of serviceData.contents.bottomRow; track
                        $index) { <div class="bg-white rounded-xl p-6 max-w-[417px]">
                            <img [src]="card.img" alt="" class="aspect-[370/250] rounded-extra-small">
                            <p class="text-xl text-black mt-6">{{t(card.title)}}</p>
                            <p class="text-[#50575f] mt-3">{{t(card.description)}}</p>
                            <button *ngIf="card.ctaLink && card.ctaTitle" class=" font-semibold"
                                (click)="openVrModalComponent()" type="button" [localizedRouterLink]="card.ctaLink"
                                class="btn-secondary mt-8">{{t(card.ctaTitle)}}</button>
                        </div> } </div>
                </div>
            </section> } <section class="flex flex-col gap-6 mt-16">
                <div class="w-full text-black text-[32px] font-semibold">{{t(serviceData.section1Title)}}</div>
                <p *ngIf="serviceData.whyChooseServiceDesc" class="text-black">{{t(serviceData.whyChooseServiceDesc)}}
                </p> @for (why of serviceData.whyChooseService; track $index) { <div
                    class="flex flex-col lg:flex-row h-auto p-8 rounded-lg border border-[#c2ccd3] justify-start items-start gap-12">
                    <div class="p-3.5 bg-[#a5f5ce] rounded-lg justify-start items-center gap-2 flex text-end">
                        <div class="w-8 h-8 relative">
                            <i [ngClass]="why.icon" class="text-3xl"></i>
                        </div>
                    </div>
                    <div class="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
                        <div class="self-stretch text-black text-2xl font-normal" [innerHTML]="t(why.title)"></div>
                        <div class="self-stretch opacity-90 text-[#50575f] text-base font-normal"
                            [innerHTML]="t(why.description)">
                        </div>
                    </div>
                </div> }
            </section> @if(serviceType == serviceTypeForTemplate.photography) { <section class="mt-16">
                <div class="text-black text-[32px] font-semibold">{{t('betterResults')}}</div>
                <div
                    class="flex flex-col lg:flex-row justify-between bg-gray-50 rounded-lg p-8 xl:gap-14 lg:gap-10 gap-8">
                    @for(item of serviceData.betterResults; track $index) { <div
                        class="flex flex-col gap-0 border-b lg:border-r lg:border-b-0 border-gray-200 flex-1 pb-6 lg:pb-0">
                        <p class="text-primary-600 text-8xl pb-6">{{item.percent}}%</p>
                        <p class="text-black">{{t(item.label)}}</p>
                    </div> } </div>
            </section> } <section class="flex flex-col gap-6 mt-16">
                <div class="text-black text-[32px] font-semibold">{{t(serviceData.section2Title)}}</div>
                <div class="home-stepper p-8 flex flex-col">
                    <div class="flow-root">
                        <ul role="list" class="-mb-8 "> @for (step of serviceData.nextSteps; track $index; let last =
                            $last) { <li>
                                <div class="relative pb-10"> @if (!last) { <span
                                        class="hidden md:block absolute left-6 top-4 -ml-px h-full w-0.5 bg-gray-200"
                                        aria-hidden="true"></span> } <div
                                        class="relative flex flex-col space-y-3 md:flex-row md:space-x-3 gap-4 lg:items-center">
                                        <div>
                                            <span
                                                class="flex h-12 w-12 font-semibold text-2xl text-primary-700 bg-gray-100 transition-all items-center justify-center rounded-full ring-8 ring-white">
                                                {{$index + 1}} </span>
                                        </div>
                                        <div class="grow shrink basis-0 pt-2 justify-center items-center gap-2 flex">
                                            <div class="grow shrink basis-0 text-[#2f3237] text-xl font-normal">
                                                {{t(step)}} </div>
                                        </div>
                                    </div>
                                </div>
                            </li> } </ul>
                    </div> @if(serviceType == serviceTypeForTemplate.photography) { <div
                        class="bg-cyan-50 border border-cyan-400 rounded-lg p-4 flex flex-row mt-14">
                        <div>
                            <i class="icon-lightbuld-2 text-cyan-600 pr-4"></i>
                        </div>
                        <div> {{t('steps-notification-photography')}} </div>
                    </div> }
                </div>
            </section> @if (serviceData.extraSection) { <section class="flex flex-col gap-6 mt-16">
                <span class="self-stretch opacity-90 text-[#50575f] text-base font-normal"
                    [innerHTML]="t(serviceData.extraSection)"></span>
            </section> } <section class="xl:hidden"> @if (serviceType == serviceTypeForTemplate.technicalReport ||
                serviceType == serviceTypeForTemplate.legalReport) { <aside
                    class="w-auto h-auto overflow-hidden content-center items-center">
                    <div
                        class="overflow-hidden xl:h-[455px] flex flex-col gap-2 items-center md:gap-6 bg-white rounded-md p-6 shadow-[0px_3px_24px_0px_#0000000A]">
                        <img [src]="serviceData.reportSampleImageUrl" width="250" height="310" />
                        <button class="btn-secondary-sm justify-center"
                            (click)="openFilePreview(serviceData.reportSampleImageUrl)"><i
                                class="icon-eye"></i>{{t('viewDocument')}} </button>
                    </div>
                </aside> } </section>
            <section class="flex flex-col gap-6 mt-16">
                <div class="h-auto flex flex-col justify-start items-start gap-8">
                    <div class="self-stretch flex-col justify-start items-start gap-4 flex">
                        <div class="text-black text-[32px] font-semibold">{{t(serviceData.section3Title)}}</div>
                        <div class="self-stretch opacity-90 text-[#50575f] text-base font-normal">
                            {{t(serviceData.section3Description)}}</div>
                    </div>
                    <div class="w-full overflow-hidden">
                        <div
                            class="card-wrapper w-full flex flex-row gap-6 mt-6 scrollbar-hidden xl:grid xl:overflow-x-visible xl:grid-cols-[repeat(auto-fit,287px)]">
                            @for (service of serviceData.services; track $index) {
                            <app-service-card class="md:flex-1 max-w-[287px]" [serviceType]="service.type"
                                [title]="t(service.title)" [subtitle]="t(service.description)"
                                [ctaTitle]="t(service.ctaLabel)" [imagePath]="service.img" (navigate)="reload($event)">
                            </app-service-card>
                            }
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="flex flex-col sticky top-24 gap-10 w-3/12 flex-none">
            <aside class="xl:block hidden z-[20]">
                <div class="xl:h-auto xl:w-[283px] xl:flex xl:flex-col xl:gap-6 bg-white xl:relative xl:rounded-b-medium rounded-t-medium p-6 shadow-[0px_3px_24px_0px_#0000000A]"
                    [ngClass]="{
                                'h-32': (isMobile$ | async) && !isOpen,
                                'h-40': !(isMobile$ | async) && !isOpen,
                                'h-auto': !(isMobile$ | async) && isOpen,
                                }">
                    <h3 class="text-black font-semibold rfs:text-2xl md:mb-0 mb-5 flex flex-row justify-between">
                        {{t('asideTitle')}} <button (click)="toggleAside()" type="button"
                            class="xl:hidden text-primary-600">
                            <i [ngClass]="{
                                            'icon-chevron-down': isOpen,
                                            'icon-chevron-up': !isOpen,
                                          }"></i>
                        </button>
                    </h3>
                    <button (click)="requestSelectedService()"
                        class="lg:hidden w-full btn-primary text-wrap flex flex-row items-center justify-center mb-4">
                        {{t(serviceData.requestServiceButtonLabel)}} </button>
                    <app-experts-callback [property]="propertySummary"
                        [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
                    <button (click)="requestSelectedService()"
                        class="hidden lg:flex btn-primary text-wrap flex-row items-center justify-center w-full mb-4">
                        {{t(serviceData.requestServiceButtonLabel)}} </button>
                </div>
            </aside>
            @if (serviceType == serviceTypeForTemplate.technicalReport || serviceType
            == serviceTypeForTemplate.legalReport || serviceType == serviceTypeForTemplate.biddingSupport) { <aside
                class="w-auto h-auto overflow-hidden content-center items-center hidden xl:block">
                <div
                    class="overflow-hidden rfs:h-[455px] w-dvw lg:w-[283px] flex flex-col gap-6 bg-white rounded-md p-6 shadow-[0px_3px_24px_0px_#0000000A]">
                    <img [src]="serviceData.reportSampleImageUrl" width="250" height="310" />
                    <button class="btn-secondary-sm justify-center"
                        (click)="openFilePreview(serviceData.reportSampleImageUrl)"><i
                            class="icon-eye"></i>{{t('viewDocument')}} </button>
                </div>
            </aside> }
        </div>
        <aside class="w-auto h-auto overflow-hidden content-center items-center flex xl:hidden">
            <div
                class="rounded-t-medium border-t border-gray-200 z-[50] p-6 bg-white overflow-y-auto fixed right-0 w-full left-0 bottom-0">
                <div class="flex flex-row justify-between items-center">
                    <h3 class="text-black font-semibold rfs:text-2xl md:mb-0 mb-5 flex flex-row justify-between">
                        {{t('asideTitle')}}</h3>
                    <button role="button" class="cursor-pointer">
                        <i class="text-black hover:text-primary-600"
                            [ngClass]="isOpen ? 'icon-chevron-up' : 'icon-chevron-down'" (click)="toggleAside()"></i>
                    </button>
                </div>
                <button (click)="requestSelectedService()"
                    class="mt-4 xl:hidden w-full btn-primary text-wrap flex flex-row items-center justify-center w-full mb-4">
                    {{t(serviceData.requestServiceButtonLabel)}} </button>
                <div *ngIf="isOpen" class="divider-line1 border-b-tone-05 my-4"></div> @if (isOpen) { <div
                    class="relative">
                    <app-experts-callback [property]="propertySummary"
                        [modalComponent]="'GeneralCallbackModal'"></app-experts-callback>
                </div> }
            </div>
        </aside>

<app-floating-banner *ngIf="serviceType === serviceTypeForTemplate.photography"></app-floating-banner>